import React from "react";
import { useTranslation } from "react-i18next";
import AccordionSection from "./AccordionSection";

const METHOD_SECTION_ORDER = [
  "foundations",
  "context",
  "architecture",
  "execution",
  "quality",
  "governance",
];

export default function MethodWindowContent({ isMaximized = false }) {
  const { t } = useTranslation("aiPortfolio");
  const sections = METHOD_SECTION_ORDER;
  const [openSection, setOpenSection] = React.useState(sections[0]);

  React.useEffect(() => {
    setOpenSection(sections[0]);
  }, [sections]);

  return (
    <div className={`methodDoc ${isMaximized ? "maximized" : "compact"}`} aria-label={t("method.accordionAriaLabel")}>
      <p className="methodDocIntro">{t("method.summary")}</p>

      {sections.map((sectionKey) => {
        return (
          <AccordionSection
            key={sectionKey}
            sectionId={sectionKey}
            openSection={openSection}
            onOpenSection={setOpenSection}
            title={t(`method.sections.${sectionKey}.title`)}
          >
            <ul>
              {t(`method.sections.${sectionKey}.points`, { returnObjects: true }).map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          </AccordionSection>
        );
      })}

      <p className="methodDocOutro">{t("method.closing")}</p>
    </div>
  );
}
